var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block-container"},[_vm._t("default"),_vm._v(" "),(_vm.block)?_c('div',{staticClass:"block-mask"},[_c('div',{staticClass:"block-message"},[_vm._t("message",function(){return [_vm._v("\n\t\t\t\t"+_vm._s(_vm.$t('block.default'))+"\n\t\t\t")]})],2)]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }